import { useDispatch, useSelector } from "react-redux";
import { PROJECTALL, USERALL, COMPANY, PROJECT } from "../../services/actions";

import React from "react";
import { Box } from "@mui/material";

import Form from "./Form";


export default function ErrorMail() {
  let dispatch = useDispatch();
  const [defV, setDefV] = React.useState({});
  const [open, setOpen] = React.useState({});
  const [companies, setCompanies] = React.useState([]);
  const fetchUsers = (page = 0) => {
    const url = page === 0 ? `user/${page}/` : `user/?page=${page}`; // pass page number
    dispatch({ type: `${USERALL}_GET`, payload: url });
  };
  let companyState = useSelector((state) => state?.companyState);
  let userState = useSelector((state) => state?.userState);
  let projectallState = useSelector((state) => state?.projectallState);
  let user = useSelector((state) => state?.loginState?.auth);

  React.useEffect(() => {
    try {
      dispatch({ type: `${COMPANY}_GET`, payload: 0 });
      //dispatch({ type: `${USERALL}_GET`, payload: 0 })
      fetchUsers(0);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  React.useEffect(() => {
    if (userState.success) {
      setOpen(false);
      dispatch({ type: `${USERALL}_GET`, payload: 0 });
    }
  }, [userState?.data]);

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Box fontWeight={700} fontSize={14} minWidth={200}>
          {user.main_role} / {"Schedule Error Email"}
        </Box>
        <Form
          key="error-mail-form"
          companies={companyState?.data?.results}
          projects={projectallState?.data?.results}
          defaultValues={defV}
          onSubmit={(data) => {
            data.error_email = data.error_email.trim().replaceAll("\n", ",");
            data.id = data.project;
            let action = data.id ? `${PROJECT}_PATCH` : `${PROJECT}_POST`;
            dispatch({ type: action, payload: data });
            setDefV({ ...data });
          }}
          onChange={(action, value) => {

            if (value) {
              dispatch({
                type: `${PROJECTALL}_GET`,
                payload: `project/0/?filter_by={"company":"${value}"}`,
              });
            }
          }}
        />
      </Box>
    </>
  );
}
